// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--8m9IF";
export var item = "Footer-module--item--13j4d";
export var list_item = "Footer-module--list_item--2I5V8";
export var footer_site_title = "Footer-module--footer_site_title--2s51e";